import React from 'react';
import './FooterPage.css';

const FooterPgae = () => {
  return (
    <footer className="FooterPgae_wrapper">
      <div className="FooterPgae_scene">
        <div className="FooterPgae_hill FooterPgae_hill--left">
          <div className="FooterPgae_building FooterPgae_building--1"></div>
          <div className="FooterPgae_building FooterPgae_building--2"></div>
        </div>

        <div className="FooterPgae_hill FooterPgae_hill--right">
          <div className="FooterPgae_windmill FooterPgae_windmill--1">
            <span className="FooterPgae_blades"></span>
          </div>
          <div className="FooterPgae_windmill FooterPgae_windmill--2">
            <span className="FooterPgae_blades"></span>
          </div>
          <div className="FooterPgae_building FooterPgae_building--3"></div>
          <div className="FooterPgae_building FooterPgae_building--4"></div>
          <div className="FooterPgae_tree FooterPgae_tree--3"></div>
        </div>

        <span className="FooterPgae_cloud FooterPgae_cloud--1"></span>
        <span className="FooterPgae_cloud FooterPgae_cloud--2"></span>
        <span className="FooterPgae_cloud FooterPgae_cloud--3"></span>

        <div className="FooterPgae_content">
          <img
            className="FooterPgae_logo"
            src="https://res.cloudinary.com/dk50cmtps/image/upload/v1786336638/592f1aee-a328-4135-bd3f-8a1e20477346_smm1fr.png"
            alt="Company Logo"
          />
          <p className="FooterPgae_address">
            8th Floor, Eastern Wing, Polyhose Towers, 86, Anna Salai, Guindy,
            Chennai, Tamil Nadu 600032
          </p>
        </div>
      </div>

      <div className="FooterPgae_bottomBar">
        <span className="FooterPgae_copyright">
          &copy; Copyright  2026 Upskld  - All Rights Reserved.
        </span>
      </div>
    </footer>
  )
}

export default FooterPgae